module.exports = __webpack_public_path__ + "img/course1.fe72b14c.png";